import * as yup from 'yup'

const schema = {
  dueDate: yup.string().required(),
  title: yup.string().required(),
}

export const preCheckDetailsValidationSchema = yup.object().shape(schema)
